<!-- <div id="pond_saving" class="p-3 bg-warning color-white"> -->
<!-- 	<p class="small uc text-center mb-0"><i class="fas fa-fw fa-spinner fa-spin"></i> Ajout de la mare en cours</p> -->
<!-- </div> -->
<? if( pond.get('todo') == 'create' ) { ?>
	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Mare ajoutée avec succès</p>
	</div>
<? } else { ?>
	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Détails de la mare</p>
	</div>
<? } ?>

<div class="p-3 text-center bb">
	<p>
		<? if( !pond.isNew() ) { ?>
			<span class="badge badge-dark badge-lg fw-400 mr-1">Mare #<span class="pond_id"><?=pond.toFixed( 'id', 0 )?></span></span>
		<? } else if( app.is('online') ) { ?>
			<span class="badge badge-dark badge-lg fw-400 mr-1">Mare #<i class="fas fa-fw fa-spinner fa-spin"></i></span>
		<? } else { ?>
			<span class="badge badge-dark badge-lg fw-400 mr-1">Mare <i class="fad fa-xs fa-fw fa-wifi-slash"></i></span>
		<? } ?>

		<span class="badge badge-<?=pond.getStatus().color?> badge-lg fw-400"><?=pond.getStatus().name?></span>
	</p>
	<p class="text-center text-secondary small mb-0">
		<? if( pond.hasError() ) { ?>
			<? _.each( pond.getErrors(), function( error ) { ?>
				<strong class="text-danger"><?=error?></strong>
			<? }) ?>
		<? } else if( !pond.isNew() ) { ?>
			Ajoutée le <?=pond.getDate('created_at')?>
		<? } else if( app.is('online' ) ) { ?>
			Synchronisation en cours…
		<? } else { ?>
			En attente de synchronisation…
		<? } ?>
		<? if( pond.has('user_name') ) { ?>
			<br/>par <?=pond.get('user_name')?>
		<? } ?>
	</p>
</div>

<div class="pt-2 pb-2 px-3 bb">
	<div class="d-flex justify-content-start align-items-center">
		<div><i class="far fa-2x fa-fw fa-map-marker-alt color-green"></i></div>
		<div class="ml-2">
			<? if( pond.has('city_name') ) { ?>
				<small><?=pond.get('city_name')?></small>
			<? } else { ?>
				<small><?=zone.get('name')?> (<?=zone.get('id')?>)</small>
			<? } ?>
			<br/><strong><?=pond.toFixed('lat',6)?>&nbsp;&nbsp;<?=pond.toFixed('lng',6)?></strong>
		</div>
	</div>
</div>
<? if( pond.getImageList().length ) { ?>
	<div>
		<div class="p-3">
			<p class="fw-600 color-green mb-0">Photos de la mare</p>
		</div>

		<div id="image-carousel" class="carousel slide" data-ride="carousel">
			<ol class="carousel-indicators">
				<? _.each( pond.getImageList(), function( image, i ) { ?>
					<li data-target="#image-carousel" data-slide-to="<?=i?>" class="<?=(i?'':'active')?>"></li>
				<? }) ?>
				<li data-target="#image-carousel" data-slide-to="<?=pond.getImageList().length?>"></li>
			</ol>
			<div class="carousel-inner">
				<? _.each( pond.getImageList(), function( $image, $i ) { ?>
					<div class="carousel-item <?=( $i ? '' : 'active' )?>">
						<?-$image.toHTML( 'a', { "data-fancybox": "gallery", "data-caption": $image.get('legend') } )?>
					</div>
				<? }) ?>
				<div class="carousel-item">
					<a href="#<?=pond.toUrl('image/create')?>" class="img-gow text-white" style="background-image:url(img/photo_blank.png)">
						<strong class="d-block w-100 py-3 text-center position-absolute lead fw-600">Ajouter une photo</strong>
					</a>
				</div>
			</div>
			<a class="carousel-control-prev" href="#image-carousel" role="button" data-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
			</a>
			<a class="carousel-control-next" href="#image-carousel" role="button" data-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
			</a>
		</div>

		<div>
			<? /* _.each( pond.getImageList(), function( image ) { ?>
				<? // image.toHTML( 'a', { "data-fancybox":"gallery", "data-caption":image.get('legend'),"data-id":image.get('id')} )?>
				<a href="<?=image.get('url')?>" data-fancybox="gallery" data-caption="<?=image.get('legend')?>" class="d-block" data-id="<?=image.get('id')?>">
					<img src="<?=image.get('thumb')?>" alt="" class="w-100" style="border-bottom: 2px solid #fff;" />
				</a>
			<? }) */ ?>
		</div>
	</div>
<? } ?>

<div class="p-3">
	<p class="fw-600 color-green mb-0">Visites détaillées</p>
</div>

<div class="visit-list">
	<? if( pond.getVisitList().length ) { ?>
		<div class="list-group status-visited">
			<? _.each( pond.getVisitList(), function( visit ) { ?>
				<a href="#<?=visit.toUrl('visit/view')?>" class="list-group-item list-group-item-action bg-light">
					<div class="d-flex justify-content-between align-items-center">
						<div>
							Visite du <?=visit.getDate('date')?><br/>
							<span class="small text-secondary">par <?=visit.get('user_name')?></span>
						</div>
						<div><?-visit.getIcon()?></div>
					</div>
				</a>
			<? }) ?>
		</div>
	<? } else { ?>
		<div class="list-group">
			<div class="list-group-item">
				<em class="text-secondary">Aucune visite pour l'instant</em>
			</div>
		</div>
	<? } ?>
</div>

<? if( !pond.hasError() ) { ?>
	<div class="p-3 row">
		<div class="col-6"><a href="#<?=pond.toUrl('visit/create')?>" class="btn btn-green btn-block mr-2"><i class="fa fa-edit"></i> Ajouter une visite</a></div>
		<div class="col-6"><a href="#<?=pond.toUrl('image/create')?>" class="btn btn-green btn-block"><i class="fa fa-camera"></i> Ajouter une photo</a></div>
	</div>
<? } ?>


<? if( !pond.isNew() && pond.get('status') == 'lost' ) { ?>
	<div class="p-3 bt">
		<button data-toggle="modal" data-target="#pond-found-modal" class="btn btn-secondary btn-block">Mare retrouvée ?</button>
	</div>
	<div id="pond-found-modal" class="modal">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Attention !</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p>Vous êtes sur le point de déclarer la mare comme retrouvée.<br/><br/>Veuillez confirmer cette action pour changer le statut.</p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
					<button type="button" class="btn btn-green" data-pond-status="visited">Confirmer</button>
				</div>
			</div>
		</div>
	</div>
<? } ?>

<? if( !pond.isNew() && pond.get('status') != 'lost' ) { ?>
	<div class="p-3 bt">
		<button data-toggle="modal" data-target="#pond-lost-modal" class="btn btn-secondary btn-block">Mare non-retrouvée ?</button>
	</div>
	<div id="pond-lost-modal" class="modal">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Attention !</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p>Vous êtes sur le point de déclarer la mare comme non-retrouvée.<br/><br/>Veuillez confirmer cette action pour changer le statut.</p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
					<button type="button" class="btn btn-green" data-pond-status="lost">Confirmer</button>
				</div>
			</div>
		</div>
	</div>
<? } ?>

